export default {


    CATEGORY: 'category',
    METRICS: 'metrics',
    NONE: 'none'
}